import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

const Menu = Styled.div`
background-color: ${color.white};
overflow:hidden;
overflow:hidden;
border-radius: 4px;
`;

const MenuHeader = Styled.header`
width: 100%;
height: 4rem;
display: grid;
grid-template-columns: 85fr 15fr;
cursor: pointer;

`;

const SelectedValue = Styled.span`
color: ${(props) => (props.selected ? color.primary : color.secondary)};
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: center;
padding: 0 1rem;
border-right: solid 1px ${color.secondaryAlt};
`;

const MenuIcon = Styled.span`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
transition: .2s;
transform: ${(props) => (props.open ? 'rotate(180deg)' : '')}
`;

const MenuBody = Styled.body`
display: ${(props) => (props.open ? 'flex' : 'none')};
flex-direction: column;
align-items: stretch;
justify-content: stretch;
`;

const Option = Styled.div`
position: relative;
width: 100%;
color: ${color.primary}
display: flex;
flex-direction: column;
align-items: stretch;
justify-content: stretch;
border-top: solid 1px ${color.secondaryAlt};
`;

const OptionValue = Styled.span`
background: ${color.white};
text-transform: capitalize;
width:100%;
display:block;
color: ${color.secondary};
padding: 1rem;
`;

const Radio = Styled.input.attrs(({ id }) => ({
  type: 'radio',
  id: id,
  name: 'options',
}))`
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
  &:hover ~ *{background-color: ${color.lightAlt}; color: ${color.primary}}
  `;

class SelectMenu extends React.Component {
  state = {
    open: false,
    selected: '',
  };

  handleOpenMenu = () => {
    this.setState({ open: !this.state.open });
  };

  handleSelect = (event) => {
    this.setState({ open: false });
    this.setState({ selected: event.currentTarget.value });
    this.props.onSelect(event);
  };

  render() {
    const { options } = this.props;
    return (
      <Menu>
        <MenuHeader onClick={this.handleOpenMenu}>
          <SelectedValue selected={this.state.selected}>
            {this.state.selected || 'Select Option'}
          </SelectedValue>
          <MenuIcon open={this.state.open}>↓</MenuIcon>
        </MenuHeader>

        <MenuBody open={this.state.open}>
          {options.map(({ label, value }) => (
            <Option key={label}>
              <Radio
                onClick={this.handleSelect}
                data-label={label}
                value={value}
              />
              <OptionValue>{label}</OptionValue>
            </Option>
          ))}
        </MenuBody>
      </Menu>
    );
  }
}

export default SelectMenu;
